import { ChevronLeftIcon } from 'lucide-react'

import { formatDate } from '@/utils'
import type { SupportTicket } from '../types'
import { SupportPill } from './SupportPill'
import { TicketStatusBadge } from './TicketStatusBadge'

interface TicketThreadHeaderProps {
  ticket: SupportTicket
  onBack: () => void
}

export const TicketThreadHeader = ({
  ticket,
  onBack,
}: TicketThreadHeaderProps) => (
  <div className="flex items-center gap-3 border-b border-border bg-white px-5 py-3">
    <button
      type="button"
      onClick={onBack}
      aria-label="Back to tickets"
      className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg text-blue-4 transition-colors hover:bg-blue-1 hover:text-blue-7 md:hidden"
    >
      <ChevronLeftIcon className="h-5 w-5" />
    </button>

    <div className="min-w-0 flex-1">
      <h2 className="truncate text-base font-semibold text-blue-7">
        {ticket.subject}
      </h2>
      <div className="mt-0.5 flex items-center gap-2 overflow-hidden text-xs text-ink-subtle">
        <span className="shrink-0">
          Started {formatDate(ticket.createdAt, 'MMM d')}
        </span>
        {ticket.projectName && (
          <SupportPill tone="neutral">{ticket.projectName}</SupportPill>
        )}
      </div>
    </div>

    <TicketStatusBadge status={ticket.status} />
  </div>
)
